import { render } from "./Show_lama.vue?vue&type=template&id=087a346f"
import script from "./Show_lama.vue?vue&type=script&lang=js"
export * from "./Show_lama.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__